import { createRef, useEffect, type ComponentProps } from "react"
import clsx from "clsx"
import { useHover } from "usehooks-ts"

import type { Nullish, PropsWithClassName } from "~/@types/generics"
import { MULTICOLOR_HEXA } from "~/lib/shopify/constants"
import hexToHSL from "~/utils/hex-to-hsl"

import * as css from "./styles.css"

type ProductVariantsSelectorProps = PropsWithClassName<
  {
    active?: boolean
    disabled?: boolean
    hexa: Nullish<string>
    value?: string
    layout?: "large" | "light"
    onHover?(value: Nullish<ProductVariantsSelectorProps["value"]>): void
  } & ComponentProps<"div">
>

export function ColorSelector({
  className,
  layout = "large",
  value,
  active,
  disabled,
  hexa,
  onHover,
  ...rest
}: ProductVariantsSelectorProps) {
  const state = disabled ? "disabled" : active ? "active" : null
  const hsl = hexToHSL(hexa)
  const withBorder = hsl && hsl.l > 0.8

  const ref = createRef<HTMLDivElement>()
  const isHover = useHover(ref)
  const isMulticolor = hexa === MULTICOLOR_HEXA
  useEffect(() => {
    if (isHover) {
      onHover?.(value)
    }
  }, [isHover, onHover, value])

  return (
    <div
      ref={ref}
      className={clsx(
        className,
        css.ColorSelector({ layout }),
        state && css.state[state],
        withBorder && css.border,
        css
      )}
      style={{
        ...(hexa
          ? isMulticolor
            ? {
                background:
                  "linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,154,0,1) 10%, rgba(208,222,33,1) 20%, rgba(79,220,74,1) 30%, rgba(63,218,216,1) 40%, rgba(47,201,226,1) 50%, rgba(28,127,238,1) 60%, rgba(95,21,242,1) 70%, rgba(186,12,248,1) 80%, rgba(251,7,217,1) 90%, rgba(255,0,0,1) 100%)",
              }
            : { color: hexa }
          : {}),
      }}
      {...rest}
    >
      <div className={clsx(css.content({ isMulticolor }))} />
    </div>
  )
}
